import {
  VStack,
  colors,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  responsive,
  ColorIcon,
  HStack,
  customEvent,
} from "goi_common";
import { Box } from "@chakra-ui/react";

import { useRouter } from "next/router";

export default function ReviewSection() {
  const router = useRouter();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.warmGray100}
      css={responsive({
        padding: { base: "28px 12px 60px", lg: "100px 0 100px" },
      })}
    >
      <Box
        className="gray900 head_24_eb lg_head_42_b"
        textAlign="center"
        padding="38px 0 30px"
      >
        100원 상조 실제 이용 후기
      </Box>
      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "24px 30px 26px", lg: "20px 40px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              성OO 님의 후기 | 2025년 5월 17일
            </div>
            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(
                  `https://www.goifuneral.co.kr/review/942/?from=prime`
                );
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "16px", lg: "18px" },
            fontWeight: "700",
          })}
        >
          가입부터 제가 느낀 그대로 말씀드릴께요, 작년 12월쯤 광고로 고이 100원
          상조가 뜨더라구요
        </Box>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "15px", lg: "16px" },
            fontWeight: 500,
          })}
        >
          100원이니 매월100원 잃어버리는 셈치고 계약했습니다. 제 만족도는
          최고입니다, 돌아가신 날 상조에 연락하니 바로 전화왔고 장례식장
          계약부터 화장터 계약까지 모든 걸 상주측에 도움되도록 처리해주셨어요.
          그리고 비용도 중요한데 고이상조는 추가비용 전혀 없어요.
          장례지도사분께서 정말 친절하시고 많은 도움 받아서 솔직하게 감사를 떠나
          감동 먹었어요. 저도 이런 후기는 처음입니다. 고이상조 가입하시고 많은
          도움 받으시기를 바랍니다.
        </Box>
      </VStack>

      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "24px 30px 26px", lg: "20px 40px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              한OO 님의 후기 | 2025년 3월 10일
            </div>
            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(
                  `https://www.goifuneral.co.kr/review/774/?from=prime`
                );
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "16px", lg: "18px" },
            fontWeight: "700",
          })}
        >
          100원 고이상조 가볍게 가입해두었는데 정말 유용했고 많은 도움
          받았습니다.
        </Box>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "15px", lg: "16px" },
            fontWeight: 500,
          })}
        >
          불필요한 절차들이나 보다 합리적으로 장례 치를 수 있도록 많이
          안내해주셨고 불편하실수 있는 부분도 내색없이 처리해 주셨습니다.
        </Box>
      </VStack>

      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "24px 30px 26px", lg: "20px 40px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              고OO 님의 후기 | 2025년 3월 19일
            </div>

            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(
                  `https://www.goifuneral.co.kr/review/782/?from=prime`
                );
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "16px", lg: "18px" },
            fontWeight: "700",
          })}
        >
          엄마가 준비하신 상조도 있었지만 후기가 좋아서 고이로 선택했는데 정말
          잘 선택 한 거 같습니다
        </Box>
        <Box
          className="gray900"
          css={responsive({
            fontSize: { base: "15px", lg: "16px" },
            fontWeight: 500,
          })}
        >
          출산 한달만에 돌아가셔서 몸조리도 제대로 못하고 정신없는데다 컨디션도
          안 좋아서 표정관리가 안됐는데 계속 신경써주시고 저한테 맞춰
          설명해주셔서 이해도 잘 됐습니다
          <br />
          집안 어르신분들도 하나같이 모두 칭찬하셨어요
        </Box>
      </VStack>

      <NextLink
        href="https://www.goifuneral.co.kr/review/?from=prime"
        css={responsive({
          width: { base: "100%", lg: "400px" },
          padding: "20px 24px 0",
          marginTop: "40px",
        })}
        event={{
          newGtm: {
            path: "home",
            trigger_and_target: "CTA-uv_review",
          },
        }}
      >
        <LargeButton
          className="subtitle_18_b"
          buttonType={LARGEL_BUTTON_TYPE.ORANGE}
          height={52}
        >
          더 많은 실제 후기 확인하기
        </LargeButton>
      </NextLink>
    </VStack>
  );
}
